import OrganizationSignUpValidation from "./organizationSignUp.validation";
import PhysicianSignUpValidation from "./physicianSignUp.validation";
import SignUpFlowValidation from "./signUpFlow.validation";
import UserSignUpValidation from "./userSignUp.validation";
import InviteUserValidation from "./inviteUser.validation";
import EditPortalUserFormValidation from "./editPortalUser.validation";
import EditMyProfileValidation from "./editProfile.validation";
import ApproveOrderValidation from "./ApprovalOrderValidation";
import ForgotPasswordValidation from "./forgotPassword.validation";
import GenerateLabelValidation from "./GenerateLabelvalidation";
import PatientInformationValidation from "./patientInfoValidation";
import PatientPersonalInfoValidation from "./patientPersonalInfo.validation";
import PatientContactInfoValidation from "./patientContactInfo.validation";
import PatientSecurityInfoValidation from "./patientSecurityInfo.validation";
import SecurityInfoValidation from "./securityInfo.validation";
import OrganizationEditValidation from "./organizationEdit.validation";
import TRFOrderValidation from "./TRFOrder.validation";
import addDocumentsValidation from "./addDocuments.validation";
import DocumentDropOffValidation from "./DocumentDropOff.validation";
import ProfileForm from "../../components/global/forms/ProfileForm";
import ProfileFormValidation from "./ProfileFormValidation.validation";

const validations = {
  organizationSignUp: OrganizationSignUpValidation,
  organizationEditValidation: OrganizationEditValidation,
  userSignUp: UserSignUpValidation,
  physicianSignUp: PhysicianSignUpValidation,
  signUpFlow: SignUpFlowValidation,
  inviteValidation: InviteUserValidation,
  editPortalUserValidation: EditPortalUserFormValidation,
  editProfileValidation: EditMyProfileValidation,
  patientInformationValidation: PatientInformationValidation,
  patientPersonalInfoValidation: PatientPersonalInfoValidation,
  patientContactInfoValidation: PatientContactInfoValidation,
  patientSecurityInfoValidation: PatientSecurityInfoValidation,
  forgotPasswordValidation: ForgotPasswordValidation,
  approvalOrderValidation: ApproveOrderValidation,
  generateLabelValidation: GenerateLabelValidation,
  securityInfoValidation: SecurityInfoValidation,
  trfOrderValidation: TRFOrderValidation,
  addDocumentsValidation: addDocumentsValidation,
  documentDropOffValidation: DocumentDropOffValidation,
  profileFormValidation: ProfileFormValidation
};

export default validations;
